import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// /result_complete?safe=true&host=simple.life&country=US&lang=en&utm_source=FB&area=activity-female-tai-chi-walking-v2-al&mock-data=true&exp=web_tai_chi_al_paywall_plan_benefits~1
		'activity-female-tai-chi-walking-v2-al': {
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_tai_chi_al_paywall_plan_benefits'),
			},
		},
	},
]

export default config
